<template>
  <div
    :class="bannerStyles"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" :class="$style.proTipIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.188 14c.187 0 .28-.094.28-.281a.658.658 0 00-.015-.11.658.658 0 01-.016-.109 22.972 22.972 0 01-.093-2.563c.02-.708.093-1.343.218-1.906.042-.208.167-.52.375-.937.459.02 1.073.135 1.844.344.771.208 1.354.395 1.75.562l.313.156c.25.104.479.156.687.156h.094c.313-.02.667-.229 1.063-.624.312-.292.562-.646.75-1.063l.093-.281c.313-.771.469-1.688.469-2.75 0-1.042-.156-1.959-.469-2.75a.34.34 0 01-.062-.125.511.511 0 01-.031-.125A3.423 3.423 0 0012.688.5c-.376-.333-.76-.5-1.157-.5-.25 0-.5.063-.75.188-.02 0-.041.01-.062.03-.021.022-.042.032-.063.032-1.604.958-3.302 1.48-5.094 1.563H3.657c-.541.229-.984.609-1.328 1.14a3.13 3.13 0 00-.515 1.735c0 1.208.49 2.104 1.468 2.687.104.083.271.167.5.25.23.083.417.161.563.234.146.073.208.162.187.266-.02.167-.062.36-.125.578a3.609 3.609 0 00-.093.36l-.094.312c-.063.188-.13.427-.203.719a24.89 24.89 0 00-.22.969c-.072.354-.135.76-.187 1.218a20.88 20.88 0 00-.109 1.313v.219c0 .124.094.187.281.187h2.406zm5.687-5.594c-.313 0-.615-.344-.906-1.031-.313-.77-.469-1.698-.469-2.781 0-1.063.156-1.98.469-2.75.27-.604.573-.907.906-.907.354 0 .667.303.938.907.312.77.468 1.687.468 2.75 0 1.083-.156 2.01-.469 2.781-.312.688-.624 1.031-.937 1.031zM2.781 7.375C1.74 6.792 1.22 5.895 1.22 4.687c0-.625.177-1.203.531-1.734a2.979 2.979 0 011.375-1.14h-.25c-.625 0-1.177.223-1.656.671a2.818 2.818 0 00-.875 1.672c-.23.042-.344.209-.344.5 0 .334.125.5.375.5.104.584.354 1.078.75 1.485.396.406.865.63 1.406.671h.094l.063.032.062.031h.031z" fill="#409DAD"/></svg>
    <span :class="$style.strong">Pro-tip: </span>
    <slot />
  </div>
</template>

<script>

export default {
  name: 'TemplateProtipBanner',

  props: {
    bannerCustomClass: {
      type: [String, Array],
      default: '',
    },
  },

  computed: {
    bannerStyles() {
      if (Array.isArray(this.bannerCustomClass)) {
        return [
          this.$style.banner,
          ...this.bannerCustomClass,
        ];
      }
      return [this.$style.banner, this.bannerCustomClass];
    },
  },
};
</script>

<style module>

.banner {
  background-color: rgba(208, 230, 235, 0.3);
  border: 2px solid #409dae;
  border-radius: 4px;
  font-size: 16px;
  margin: 0 auto;
  margin-bottom: 50px;
  margin-top: 15px;
  max-width: 340px;
  padding: 15px 10px;
}

.proTipIcon {
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
}

.strong {
  font-weight: bold;
}

</style>
